module.exports = (__webpack_require__(48870))(72);